import { commonConstants } from "./types";
import { setAydinlatmaMetni, getAydinlatmaMetni } from "../../../services/common.service";
import { alertActions, loading } from "../alert/actions";
import { beginLogout } from "../login/actions";

const endError = error => {
  return dispatch => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } 
    else {
      dispatch(alertActions.error(error));
      dispatch({
        type: commonConstants.AYDINLATMA_ERROR,
        error
      });
    }
  }
}

const setAydinlatma = () => {
  return dispatch => {
    dispatch(request('aydinlatma'));
    dispatch(loading.showLoading());
    setAydinlatmaMetni().then(
      response => {
        dispatch(success(response));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request(response) {
    return { type: commonConstants.SET_AYDINLATMA_REQUEST, payload: { response } };
  }
  function success(data) {
    return { type: commonConstants.SET_AYDINLATMA_SUCCESS, payload: { aydinlatma: data } };
  }
};

const getAydinlatma = () => {
  return dispatch => {
    dispatch(request());
    getAydinlatmaMetni().then(
      response => {
        dispatch(success(response.data));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: commonConstants.GET_AYDINLATMA_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: commonConstants.GET_AYDINLATMA_SUCCESS,
      payload: { aydinlatma: data }
    };
  }
};

const hideAydinlatmaModal = () => {
  return { type: commonConstants.HIDE_AYDINLATMA_MODAL };
};

export { setAydinlatma, getAydinlatma, hideAydinlatmaModal };
